module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flowing-text2.d0161d23.png";